import { useEffect, useRef, useState } from 'react';
import api from './http';

// Minimal connectivity hook: pings /api/health on an interval with a timeout.
// Returns { serverReachable: boolean, latencyMs?: number, lastOkAt?: number }
export function useConnectivity({ intervalMs = 10000, timeoutMs = 3000 } = {}) {
  const [serverReachable, setServerReachable] = useState(undefined);
  const [latencyMs, setLatencyMs] = useState(undefined);
  const [lastOkAt, setLastOkAt] = useState(undefined);
  const timerRef = useRef(null);
  const inFlight = useRef(false);

  useEffect(() => {
    const ping = async () => {
      if (inFlight.current) return;
      inFlight.current = true;
      const start = performance.now();
      try {
        await api.get('/api/health', { timeout: timeoutMs });
        const dur = performance.now() - start;
        setLatencyMs(dur);
        setServerReachable(true);
        setLastOkAt(Date.now());
      } catch (_) {
        setServerReachable(false);
      } finally {
        inFlight.current = false;
      }
    };
    // immediate ping, then interval
    ping();
    timerRef.current = setInterval(ping, intervalMs);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [intervalMs, timeoutMs]);

  return { serverReachable, latencyMs, lastOkAt };
}
